module.exports = __webpack_public_path__ + "static/flags/FK-b64a5318690e2b33953389cefb362ced.gif";